import type { HTMLAttributes, ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ULThemeTitleProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * The title of the screen.
   */
  children: ReactNode;
  /**
   * Optional class names for additional styling or overriding default styles.
   */
  className?: string;
  weight?: "bold" | "semibold" | "light";
}

const ULThemeTitle = ({
  children,
  className,
  weight,
  ...rest
}: ULThemeTitleProps) => {
  const themedStyles =
    "text-header justify-text-header text-(length:--ul-theme-font-title-size) font-title";

  let fontFamilyClass = "GretaSansL-Regular, sans-serif";
  switch (weight) {
    case "bold":
      fontFamilyClass = "GretaSansL-Bold, sans-serif";
      break;
    case "semibold":
      fontFamilyClass = "GretaSansL-Semibold, sans-serif";
      break;
    case "light":
      fontFamilyClass = "GretaSansL-Light, sans-serif";
      break;
  }

  return (
    <h1
      style={{ fontFamily: fontFamilyClass }}
      className={cn(themedStyles, className)}
      {...rest}
    >
      {children}
    </h1>
  );
};

export default ULThemeTitle;
// Test comment
// Another test comment
